module.exports = __webpack_public_path__ + "img/spIcon2.662fa809.png";